import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import styles from './title.module.scss';
const TitleComponent = ({ settingTitle, actions, actionHandler, titleSize = 'medium', }) => (React.createElement("div", { key: settingTitle, className: styles.searchSettingsHeader },
    React.createElement(Typography, { role: "heading", "aria-level": 1, variant: titleSize === 'large' ? 'h2' : 'p-large-bold', className: styles.searchSettings }, settingTitle),
    actions &&
        actions.map(action => {
            if (action.type) {
                return (React.createElement("div", { className: styles.actionButton, key: action.title },
                    React.createElement(Button, { text: `${action.title}`, type: "secondary", key: action.type, onClick: () => actionHandler(action.type) })));
            }
            return null;
        })));
export const Title = React.memo(TitleComponent);
//# sourceMappingURL=title.js.map